// Clinical-exclusion conditions offered for a CMS $unalign with reason
// 'no-longer-clinically-eligible'. CMS binds Condition.code to ICD-10-CM at REQUIRED
// strength — the display MUST equal the ICD-10-CM canonical descriptor exactly (drift → 400).
// The frontend sends the CODE only; WF24 re-derives the canonical display from its own
// copy of this list, so a client bug can't drift the display CMS sees.
// KEEP IN SYNC with WF24's EXCLUSION table (24-cms-unalignment.json, Build FHIR Unalignment Parameters).
export interface ClinicalExclusionCondition {
  code: string; // ICD-10-CM code — the wire contract between frontend, WF24, and CMS
  display: string; // exact ICD-10-CM canonical descriptor (verified — do not paraphrase)
  label: string; // operator-facing label (UI only — never sent to CMS)
}

export const CLINICAL_EXCLUSION_CONDITIONS: ClinicalExclusionCondition[] = [
  { code: 'N18.6', display: 'End stage renal disease', label: 'End-stage renal disease (ESRD)' },
  { code: 'Z51.5', display: 'Encounter for palliative care', label: 'Palliative / hospice care' },
];
